import React from "react";
import styles from "./ZodiacTimeWheel.module.css";

interface ZodiacTimeWheelProps {
  activeHour?: number; // от 0 до 23
}

const ZodiacTimeWheel: React.FC<ZodiacTimeWheelProps> = ({ activeHour }) => {
  const size = 300;
  const center = size / 2;
  const radius = 130;
  const innerRadius = 50;
  const numSectors = 24;

  const sectors = Array.from({ length: numSectors }, (_, i) => {
    const startAngle = (i * 360) / numSectors - 90;
    const endAngle = ((i + 1) * 360) / numSectors - 90;

    const x1 = center + radius * Math.cos((startAngle * Math.PI) / 180);
    const y1 = center + radius * Math.sin((startAngle * Math.PI) / 180);
    const x2 = center + radius * Math.cos((endAngle * Math.PI) / 180);
    const y2 = center + radius * Math.sin((endAngle * Math.PI) / 180);

    const x1Inner = center + innerRadius * Math.cos((startAngle * Math.PI) / 180);
    const y1Inner = center + innerRadius * Math.sin((startAngle * Math.PI) / 180);
    const x2Inner = center + innerRadius * Math.cos((endAngle * Math.PI) / 180);
    const y2Inner = center + innerRadius * Math.sin((endAngle * Math.PI) / 180);

    const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

    const path = `
      M ${x1Inner} ${y1Inner}
      L ${x1} ${y1}
      A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}
      L ${x2Inner} ${y2Inner}
      A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${x1Inner} ${y1Inner}
      Z
    `;

    const midAngle = ((startAngle + endAngle) / 2) * (Math.PI / 180);
    const textRadius = (radius + innerRadius) / 2;
    const textX = center + textRadius * Math.cos(midAngle);
    const textY = center + textRadius * Math.sin(midAngle);

    return (
      <g key={i}>
        <path d={path} className={activeHour === i ? styles.activeSector : styles.inactiveSector} />
        <text
          x={textX}
          y={textY}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#fff"
          fontSize="12"
        >
          {i}
        </text>
      </g>
    );
  });

  return (
    <div className={styles.wrapper}>
      <svg className={styles.wheel} viewBox={`0 0 ${size} ${size}`}>
        {sectors}

        <circle cx={center} cy={center} r={innerRadius} fill="url(#centerGradient)" />
        <image
          href="/icons/zodiacs.svg"
          x={center - 24}
          y={center - 24}
          width="48"
          height="48"
          opacity="0.9"
        />

        <defs>
          <linearGradient id="centerGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#5b2a85" />
            <stop offset="100%" stopColor="#3b0a60" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default ZodiacTimeWheel;
